module.exports = __webpack_public_path__ + "35e53751.svg";